// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__i7dVr","spin":"PrintLink_spin__aBbsG"};